import React, { Fragment, PureComponent } from "react";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  // ReferenceLine,
} from "recharts";

import Loader from "./../../Loader/Loader.js";
import { Metric, StandardTooltip, selectFormat } from "./../../Utils/Utils.js";
import { XRayTooltip } from "./../../Utils/XrayUtils.js";

import Heading from "./../../Elements/Heading";
import { getXrayTooltipPosition } from "../../../helpers/DOM";

const color = {
  fans: "#FC6D52",
  reach: "#007bff",
  impression: "#28a745",
  engagement: "#e83e8c",
};

class InstagramKeyStats extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      widgetsData: props.data.data,
      widgetsInsights: [],
      width: 0,
      height: 0,
      tooltipTotalFans: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipReach: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipImpressions: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipEngagements: {
        show: false,
        x: 0,
        y: 0,
      },
    };

    this.node = React.createRef();
    this.totalFansPosition = React.createRef();
    this.reachPosition = React.createRef();
    this.impressionsPosition = React.createRef();
    this.engagementsPosition = React.createRef();

    this.updatePosition = this.updatePosition.bind(this);
  }

  updatePosition() {
    this.closeTooltipTotalFans();
    this.closeTooltipReach();
    this.closeTooltipImpressions();
    this.closeTooltipEngagements();

    if (!this.chartRef) return;
    const { containerWidth, containerHeight } = this.chartRef.state;
    this.setState({ width: containerWidth, height: containerHeight });
  }

  UNSAFE_componentWillMount() {
    this.updatePosition();
  }

  componentDidMount() {
    this.props.childRef(this);

    window.addEventListener("resize", this.updatePosition);
    window.addEventListener("click", this.handleClickOutside);

    setTimeout(() => {
      this.updatePosition();
    }, 500);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePosition);
    window.removeEventListener("click", this.handleClickOutside);
  }

  closeTooltipTotalFans = (event) => {
    this.setState({
      tooltipTotalFans: { show: false },
    });
  };
  closeTooltipReach = (event) => {
    this.setState({
      tooltipReach: { show: false },
    });
  };
  closeTooltipImpressions = (event) => {
    this.setState({
      tooltipImpressions: { show: false },
    });
  };
  closeTooltipEngagements = (event) => {
    this.setState({
      tooltipEngagements: { show: false },
    });
  };

  handleClickOutside = (e) => {
    if (this.totalFansPosition) {
      if (
        this.totalFansPosition.current &&
        !this.totalFansPosition.current.contains(e.target)
      ) {
        this.closeTooltipTotalFans();
      }
    }
    if (this.reachPosition) {
      if (
        this.reachPosition.current &&
        !this.reachPosition.current.contains(e.target)
      ) {
        this.closeTooltipReach();
      }
    }
    if (this.impressionsPosition) {
      if (
        this.impressionsPosition.current &&
        !this.impressionsPosition.current.contains(e.target)
      ) {
        this.closeTooltipImpressions();
      }
    }
    if (this.engagementsPosition) {
      if (
        this.engagementsPosition.current &&
        !this.engagementsPosition.current.contains(e.target)
      ) {
        this.closeTooltipEngagements();
      }
    }
  };

  generateDataForExport = () => {
    const data = this.props.data.metrics;
    let formattedData = [];

    Object.keys(data).map((i) =>
      formattedData.push({
        Metric: i
          .replace("_", " ")
          .split(/ /g)
          .map(
            (word) =>
              `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`
          )
          .join(" "),
        Value: selectFormat("number", data[i].value, "0,0"),
      })
    );

    return formattedData;
  };

  getExportData = () => ({
    data: this.generateDataForExport(),
    opts: {
      type: "other",
    },
  });

  render() {
    const { loading } = this.props;

    if (loading) {
      return <Loader minHeight={340} col={"col-12 col-md-6"} />;
    }

    const data = this.props.data;

    data.metrics.reach.paid = [
      { value: 100 * data.metrics.reach.paid },
      { value: 100 * (1 - data.metrics.reach.paid) },
    ];

    return (
      <div className="row key-stats border-between-metrics">
        <div
          className="col-lg-3 col-sm-6 col-12 key-stats--item"
          ref={this.totalFansPosition}
        >
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Total Fans</Heading>

              <Metric {...data.metrics.fans} size={"md"} />
            </div>
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.fans,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Total Fans",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#FC6D52",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipTotalFans: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipTotalFans.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      New Fans
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{ background: color.fans }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.fans}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="5%" stopColor={color.fans} stopOpacity={0.55} />
                  <stop offset="95%" stopColor={color.fans} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.fans})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.fans} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipTotalFans.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top: this.state.tooltipTotalFans.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipTotalFans.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipTotalFans.activeCoordinate.x + 15 + "px"
                    : this.state.tooltipTotalFans.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.totalFansPosition.current,
                        this.state.tooltipTotalFans.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipTotalFans.show ? 1.0 : 0.0,
                visibility: this.state.tooltipTotalFans.show
                  ? "visible"
                  : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipTotalFans}
                close={this.closeTooltipTotalFans.bind(this)}
              />
            </div>
          ) : null}
        </div>

        <div
          className="col-lg-3 col-sm-6 col-12 key-stats--item"
          ref={this.reachPosition}
        >
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Reach</Heading>

              <Metric {...data.metrics.reach} size={"md"} />

              {/* <div className="row pie-metric align-items-center">
                <div className="col-6">
                  <PieChart height={45} width={45}>
                    <Pie
                      dataKey="value"
                      data={data.metrics.reach.paid}
                      outerRadius="100%"
                      innerRadius="75%"
                      startAngle={450}
                      endAngle={90}
                    >
                      {data.metrics.reach.paid.map((entry, index) => (
                        <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                      ))}
                    </Pie>
                    <text
                      x="50%"
                      y="50%"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      className="piechart-metric__xsmall"
                    >
                      {numeral(data.metrics.reach.paid[0].value)
                        .divide(100)
                        .format("%")}
                    </text>
                  </PieChart>
                </div>
                <div className="col-6">
                  <h6 className="widget__metric-label ml-2 mt-2">Paid</h6>
                </div>
              </div>*/}
            </div>
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.reach,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Reach",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#007bff",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipReach: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipReach.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Post Reach
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{ background: color.reach }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.reach}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.reach}
                    stopOpacity={0.55}
                  />
                  <stop offset="95%" stopColor={color.reach} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.reach})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.reach} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipReach.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top: this.state.tooltipReach.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipReach.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipReach.activeCoordinate.x + 15 + "px"
                    : this.state.tooltipReach.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.reachPosition.current,
                        this.state.tooltipReach.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipReach.show ? 1.0 : 0.0,
                visibility: this.state.tooltipReach.show ? "visible" : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipReach}
                close={this.closeTooltipReach.bind(this)}
              />
            </div>
          ) : null}
        </div>

        <div
          className="col-lg-3 col-sm-6 col-12 key-stats--item"
          ref={this.impressionsPosition}
        >
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Impressions</Heading>

              <Metric {...data.metrics.impression} size={"md"} />
            </div>
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.impression,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Impressions",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#28a745",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipImpressions: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipImpressions.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Impressions
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.impression,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.impression}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.impression}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.impression}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.impression})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.impression} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipImpressions.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top:
                  this.state.tooltipImpressions.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipImpressions.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipImpressions.activeCoordinate.x +
                      15 +
                      "px"
                    : this.state.tooltipImpressions.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.impressionsPosition.current,
                        this.state.tooltipImpressions.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipImpressions.show ? 1.0 : 0.0,
                visibility: this.state.tooltipImpressions.show
                  ? "visible"
                  : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipImpressions}
                close={this.closeTooltipImpressions.bind(this)}
              />
            </div>
          ) : null}
        </div>

        <div
          className="col-lg-3 col-sm-6 col-12 key-stats--item"
          ref={this.engagementsPosition}
        >
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Engagements</Heading>

              <Metric {...data.metrics.engagement} size={"md"} />
            </div>
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-3">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.engagement,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Engagements",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#e83e8c",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipEngagements: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipEngagements.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Engagements{" "}
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.engagement,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.engagement}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.engagement}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.engagement}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.engagement})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.engagement} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipEngagements.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top:
                  this.state.tooltipEngagements.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipEngagements.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipEngagements.activeCoordinate.x +
                      15 +
                      "px"
                    : this.state.tooltipEngagements.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.engagementsPosition.current,
                        this.state.tooltipEngagements.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipEngagements.show ? 1.0 : 0.0,
                visibility: this.state.tooltipEngagements.show
                  ? "visible"
                  : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipEngagements}
                close={this.closeTooltipEngagements.bind(this)}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default InstagramKeyStats;
